import type { Entry } from "contentful";
import { newTabProps } from "@/lib/contentful/ui";
import type { TypeAnnouncementBannerSkeleton } from "@/types/contentful/generated";

type AnnouncementBannerFields = Entry<TypeAnnouncementBannerSkeleton, undefined, string>["fields"];

interface Props {
  fields: AnnouncementBannerFields;
  inspectorProps?: (fieldId: string) => Record<string, string> | undefined;
}

const bannerClass = "block bg-foreground text-white text-center text-base px-6 py-2 truncate";

export function AnnouncementBannerView({ fields, inspectorProps }: Props) {
  const { messageText, linkUrl, isNewTab, isEnabled } = fields;

  if (!isEnabled || !messageText) return null;

  const inspectorAttrs = inspectorProps?.("messageText");

  if (!linkUrl) {
    return (
      <aside aria-label="Site announcement" className={bannerClass} {...inspectorAttrs}>
        {messageText}
      </aside>
    );
  }

  return (
    <aside aria-label="Site announcement" className={bannerClass}>
      <a
        href={linkUrl}
        className="text-white no-underline! hover:opacity-100!"
        {...newTabProps(isNewTab ?? false)}
        {...inspectorAttrs}
      >
        {messageText}
      </a>
    </aside>
  );
}
